import { Component, OnInit, Input, trigger, state, style, animate, transition } from '@angular/core';

import { iResponseInfo } from '../../interfaces/shared/iresponseinfo';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  animations: [
    trigger('successAction', [
      state('NA', style({ 'opacity': '0', 'display': 'none' })),
      state('A', style({ 'opacity': '1', 'display': 'normal' })),
      transition('NA => A', animate(600)),
      transition('A => NA', animate(2000))
    ]),
    trigger('warningAction', [
      state('NA', style({ 'opacity': '0', 'display': 'none' })),
      state('A', style({ 'opacity': '1', 'display': 'normal' })),
      transition('NA => A', animate(600)),
      transition('A => NA', animate(2000))
    ]),
    trigger('errorAction', [
      state('NA', style({ 'opacity': '0', 'display': 'none' })),
      state('A', style({ 'opacity': '1', 'display': 'normal' })),
      transition('NA => A', animate(600)),
      transition('A => NA', animate(2000))
    ])
  ]
})
export class NotificationComponent implements OnInit {
  successMessage: string;
  warningMessage: string;
  errorMessage: string;

  constructor() { }

  ngOnInit() {

  }

  dbSuccessActionState = "NA";
  animateSuccessAction(message: string) {
    this.successMessage = message;
    this.dbSuccessActionState = "A";
    if (environment.notificationMessage.success > 0) {
      setTimeout(() => { this.dbSuccessActionState = "NA" }, environment.notificationMessage.success * 1000);
    }
  }

  dbWarningActionState = "NA";
  animateWarningAction(message: string) {
    this.warningMessage = message;
    this.dbWarningActionState = "A";
    if (environment.notificationMessage.warning > 0) {
      setTimeout(() => { this.dbWarningActionState = "NA" }, environment.notificationMessage.warning * 1000);
    }
  }

  dbErrorActionState = "NA";
  animateErrorAction(message: string) {
    if (message == null || message == "") {
      this.errorMessage = null;
      this.dbErrorActionState = "NA";
    } else {
      this.errorMessage = message;
      this.dbErrorActionState = "A";
      if (environment.notificationMessage.error > 0) {
        setTimeout(() => { this.dbErrorActionState = "NA" }, environment.notificationMessage.error * 1000);
      }
    }
  }

  clear() {
    this.dbSuccessActionState = "NA";
    this.dbWarningActionState = "NA";
    this.dbErrorActionState = "NA";
  }

  animate(ri: iResponseInfo) {
    if (ri == null) { return; }

    if (ri.isSuccess && ri.message != "") {
      this.animateSuccessAction(ri.message);
    }
    else if (ri.isWarning && ri.message != "") {
      this.animateWarningAction(ri.message);
    }
    if (ri.isError && ri.message != "") {
      this.animateErrorAction(ri.message);
    }
  }

  animateIfError(ri: iResponseInfo) {
    if (ri == null) { return; }

    if (ri.isError && ri.message != "") {
      this.animateErrorAction(ri.message);
    }
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/shared/notification.component.ts